import Handlebars from 'handlebars/dist/cjs/handlebars';
import { BASE_PATH } from '../constants';

Handlebars.registerHelper('ASSET', (str) => {
    return `${BASE_PATH}${str}`;
});
